import { api } from './api';

export interface ReportLine { subjectId: string; subjectName: string; marks: number | null; maxMarks: number; isAbsent: boolean; grade: string | null; resolved: boolean; }
export interface ReportCard {
  id: string; studentId: string; studentName: string; academicClassId: string;
  academicYear: string; term: string; status: string;
  totalObtained: number; totalMax: number; percentage: number | null; overallGrade: string | null; remarks: string | null;
  attendancePresent: number | null; attendanceTotal: number | null; finalizedAt: string | null;
  lines: ReportLine[]; unresolved: string[];
}

export const reportCardsApi = {
  get: (id: string) => api.get<ReportCard>(`/api/report-cards/${id}`),
  forClassTerm: (classId: string, term: string) => api.get<ReportCard[]>(`/api/report-cards/class/${classId}?term=${encodeURIComponent(term)}`),
  build: (b: { studentId: string; academicClassId: string; academicYear: string; term: string; examIds: string[]; includeAttendance: boolean }) =>
    api.post<ReportCard>('/api/report-cards/build', b),
  setRemarks: (id: string, remarks: string | null) => api.post<ReportCard>(`/api/report-cards/${id}/remarks`, { remarks }),
  finalize: (id: string) => api.post<ReportCard>(`/api/report-cards/${id}/finalize`, {}),
  reopen: (id: string) => api.post<ReportCard>(`/api/report-cards/${id}/reopen`, {}),
};
